import type { FC } from "react";

// Needed for scrolling calculations
export const SPACER_SIZE_PX = 32;

export const VerticalSpacer: FC<{ useProjectorScaling: boolean }> = ({
  useProjectorScaling = true,
}) => {
  return (
    <div
      className={
        // Note: keep in sync with SPACER_SIZE_PX.  We can't interpolate SPCER_SIZE_PX here because
        // Tailwind needs to see the full class name at build time.
        useProjectorScaling ? `h-[calc(32px/var(--projector-scaling-factor))]` : `h-[32px]`
      }
    />
  );
};
